import { ModalProps } from '@nextui-org/modal'

import { create } from 'zustand'
import { devtools } from 'zustand/middleware'

import { FC } from 'react'

// interface
interface IModalStore {
  activeModals: IModalItem[]
  open: (obj: IModalItem) => void
  close: (slug: string) => void
  closeAll: () => void
}

// interface
export interface IModalItem {
  name?: string
  component: FC<any>
  props?: {
    [key: string]: unknown
  }
  additional?: Omit<ModalProps, 'children'>
}

const useModal = create<IModalStore>()(
  devtools((set, get) => ({
    activeModals: [],
    open: (obj: IModalItem) => {
      const activeModals = get().activeModals

      const existIndex = activeModals.findIndex((el) => el.name === obj.name)

      if (existIndex !== -1) {
        get().close(obj.name as string)
      }

      set((state) => ({
        activeModals: [
          ...state.activeModals,
          {
            ...obj,
            name: obj.component.name,
          },
        ],
      }))
    },
    close: (anchor: string) => {
      const activeModals = get().activeModals

      const index = activeModals.findIndex((el) => el.component.name === anchor)

      if (index !== -1) {
        activeModals.splice(index, 1)

        set({ activeModals: [...activeModals] })
      }
    },
    closeAll: () => {
      set({
        activeModals: [],
      })
    },
  })),
)

export default useModal
